import axios from "./AxiosService";

export function isGDPRSet(personConsentModel) {
  if (
    personConsentModel === null ||
    (personConsentModel &&
      typeof personConsentModel.Post === "boolean" &&
      typeof personConsentModel.Email === "boolean" &&
      typeof personConsentModel.Sms === "boolean" &&
      typeof personConsentModel.Telephone === "boolean")
  ) {
    return true;
  }
  return false;
}

export default class PersonConsentService {
  GetPersonConsent(membershipNumber) {
    return axios
      .get(
        "PersonConsent",
        {
          params: { membershipNumber: membershipNumber }
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  SetPersonConsent(personConsentModel) {
    return axios
      .post("PersonConsent", personConsentModel, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        return response.data;
      });
  }
}
